// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @28.05.2021 13:27:20

import { CObjectBase_abstract } from './../abstract/SagaSchema/CObjectBase_abstract';

export class CObjectBase extends CObjectBase_abstract {
  get icon(): string {
    return 'briefcase';
  }
}
